import React from "react";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { withTranslation } from "react-i18next";

class CPSettingsIconButton extends React.Component {
  render() {
    const { t, onClick, edge, sx } = this.props;

    return (
      <IconButton
        onClick={onClick}
        sx={
          sx
            ? sx
            : {
                color: window.$brand === "PRB" ? "#17afb6" : "#017cbc",
              }
        }
        edge={edge ? edge : "end"}
      >
        <Tooltip title={t("Settings")}>
          <SettingsOutlinedIcon />
        </Tooltip>
      </IconButton>
    );
  }
}

export default withTranslation()(CPSettingsIconButton);
